import { render, staticRenderFns } from "./ShapeHeightConversionModal.vue?vue&type=template&id=54bc4456&scoped=true"
import script from "./ShapeHeightConversionModal.vue?vue&type=script&lang=js"
export * from "./ShapeHeightConversionModal.vue?vue&type=script&lang=js"
import style0 from "./ShapeHeightConversionModal.vue?vue&type=style&index=0&id=54bc4456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc4456",
  null
  
)

export default component.exports